'use client';

import { Box, Container, Stack, Typography } from '@mui/material';
import { sendGAEvent } from '@next/third-parties/google';
import { useLocale, useTranslations } from 'next-intl';
import Image from 'next/image';

import { shouldShowAnalytics } from '@/lib/cookie-consent';
import colors from '@/styles/themes/colors';

import styles from './CompanyDeckSection.module.scss';

const COMPANY_DECK_FILE = '/files/workspace-company-deck-2026.pdf';

const CompanyDeckSection = () => {
  const t = useTranslations('home.companyDeckSection');
  const locale = useLocale();

  const handleDownloadClick = () => {
    if (!shouldShowAnalytics()) return;

    sendGAEvent('event', 'company_deck_download', {
      file_name: COMPANY_DECK_FILE.split('/').pop(),
      file_extension: 'pdf',
      link_text: t('downloadLink'),
      link_url: COMPANY_DECK_FILE,
      locale,
    });
  };

  return (
    <Container component="section" maxWidth="xl" className={styles.container}>
      <Stack direction={{ xs: 'column-reverse', lg: 'row' }} spacing={3} alignItems="stretch">
        <Stack spacing={2.5} className={styles.contentCard}>
          <Typography variant="h3" component="h2" color={colors.white}>
            {t('title')}
          </Typography>
          <Typography variant="body1" color={colors.graytone200} sx={{ maxWidth: 448, lineHeight: 1.5 }}>
            {t('description')}
          </Typography>
          <Typography
            component="a"
            variant="body1"
            href={COMPANY_DECK_FILE}
            download
            onClick={handleDownloadClick}
            className={styles.downloadLink}
            sx={{ mt: 'auto', color: colors.blue500, textDecoration: 'none', alignSelf: 'flex-start' }}
          >
            {t('downloadLink')}
          </Typography>
        </Stack>
        <Box className={styles.imageCard}>
          <Image
            src="/images/home/company-deck/deck.webp"
            alt={t('imageAlt')}
            fill
            sizes="(max-width: 1024px) 100vw, 545px"
            className={styles.image}
          />
        </Box>
      </Stack>
    </Container>
  );
};

export default CompanyDeckSection;
